export default {
  changeasset:
    "The asset was updated by another user in the meanwhile and your changes cannot be stored. Please try again.",
  general: "General",
  header: "Attention",
};
